import React, { PureComponent } from 'react';

import { injectIntl, InjectedIntl } from 'react-intl';

import Button from '@atlaskit/button/standard-button';
import AddonIcon from '@atlaskit/icon/glyph/addon';
/* eslint frontbucket-patterns/no-old-tooltip: "warn" */
import Tooltip from '@atlaskit/tooltip';

import DropdownExpander from 'src/components/cards/dropdown-expander/dropdown-expander';
import urls from 'src/urls';
import { publishFact, publishUiEvent } from 'src/utils/analytics/publish';

import messages from './discovery-card.i18n';
import * as styles from './discovery-card.style';
import { DiscoveryCardBrowseClick } from './facts';
import discoveryCardImgUrl from './integrations.svg';

type DiscoveryCardProps = {
  intl: InjectedIntl;
  isCollapsed?: boolean;
  handleClose: () => void;
  toggleCollapse: (isCollapsed: boolean) => void;
};

export default injectIntl(
  class DiscoveryCardContent extends PureComponent<DiscoveryCardProps> {
    render() {
      const { intl, isCollapsed } = this.props;
      const icon = <AddonIcon label="" />;
      const label = intl.formatMessage(messages.label);

      if (isCollapsed) {
        return (
          <Tooltip position="left" content={label}>
            <Button appearance="subtle" iconBefore={icon} />
          </Tooltip>
        );
      }

      return (
        <DropdownExpander
          icon={icon}
          label={label}
          onClose={this.props.handleClose}
          onChange={this.props.toggleCollapse}
        >
          <styles.ImageContainer>
            <img alt={label} src={discoveryCardImgUrl} />
          </styles.ImageContainer>

          <styles.Description>
            {intl.formatMessage(messages.body)}
          </styles.Description>

          <styles.DividingLine />

          <styles.Link
            href={`${urls.ui.addonDirectory}?ref=discovery-card`}
            // @ts-ignore
            onClick={() => {
              publishFact(new DiscoveryCardBrowseClick());
              publishUiEvent({
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'browseAppsLink',
                source: 'discoveryCard',
              });
            }}
          >
            {intl.formatMessage(messages.browse)}
          </styles.Link>
        </DropdownExpander>
      );
    }
  }
);
